import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import unifiedCommsHero from "../assets/Hero/icewarp.jpeg"; // Replace with your hero image
import office365Image from "../assets/Hero/Office-365.jpg"; // Replace with your Office 365 image
import googleSuiteImage from "../assets/Hero/google-suite.jpg"; // Replace with your Google Suite image
import iceswapImage from "../assets/Hero/icewarp.jpeg"; // Replace with your Iceswap image
import "../assets/css/unifiedCommunicationsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const unifiedCommsData = {
  hero: {
    title: "Unified Communications",
    subtitle: "Seamless Communication Solutions for Office 365, Google Suite, and Iceswap",
  },
  introduction: {
    heading: "Why Unified Communications Matter",
    paragraphs: [
      "Unified communications integrate various communication tools into a single platform, enhancing collaboration and productivity.",
      "Our solutions provide seamless integration, robust performance, and expert support for Office 365, Google Suite, and Iceswap.",
    ],
  },
  communications: [
    {
      name: "Microsoft Office 365",
      image: office365Image,
      description: "Office 365 offers a comprehensive suite of productivity tools, including email, calendar, and collaboration apps.",
    },
    {
      name: "Google Suite",
      image: googleSuiteImage,
      description: "Google Suite provides powerful tools for communication, collaboration, and productivity, all in one platform.",
    },
    {
      name: "Iceswap",
      image: iceswapImage,
      description: "Iceswap delivers innovative communication solutions tailored to meet the needs of modern businesses.",
    },
  ],
  cta: {
    heading: "Ready to Enhance Your Communications?",
    text: "Contact us today to learn more about our Unified Communications Solutions and how we can help your business thrive.",
  },
};

export const UnifiedCommunicationsPage = ({ data }) => {
  const unifiedCommsRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = unifiedCommsRef.current.querySelectorAll(".unified-comms-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: unifiedCommsRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="unified-communications-page" ref={unifiedCommsRef}>
      {/* Hero Section */}
      <div
        className="unified-comms-hero-section"
        style={{ backgroundImage: `url(${unifiedCommsHero})` }}
      >
        <h1 className="unified-comms-animate">{unifiedCommsData.hero.title}</h1>
        <p className="unified-comms-animate">{unifiedCommsData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container unified-comms-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="unified-comms-animate">{unifiedCommsData.introduction.heading}</h2>
            {unifiedCommsData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="unified-comms-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 unified-comms-image-container">
            <img
              src={unifiedCommsHero}
              className="img-fluid unified-comms-animate"
              alt="Unified Communications"
              style={{ maxWidth: "100%" }}
            />
          </div>
        </div>
      </div>

      {/* Communications Section */}
      <div className="container unified-comms-list">
        <div className="row">
          {unifiedCommsData.communications.map((communication, index) => (
            <div key={index} className="col-md-4 communication-card unified-comms-animate">
              <img
                src={communication.image}
                className="img-fluid communication-image"
                alt={communication.name}
              />
              <h3>{communication.name}</h3>
              <p>{communication.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container unified-comms-cta">
        <h2 className="unified-comms-animate">{unifiedCommsData.cta.heading}</h2>
        <p className="unified-comms-animate">{unifiedCommsData.cta.text}</p>
        <button
          className="btn btn-primary unified-comms-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};
